import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { Client } from 'src/app/clients-module/models/clientLocation';
import { ClientService } from 'src/app/clients-module/services/client.service';
import { isThisTypeNode } from 'typescript';
import { PMSPartnerClientHinge, PMSPartnerUser } from '../../models/pmspartner';
import { PmsManagementService } from '../../services/pms-management.service';

@Component({
  selector: 'app-mapping-management',
  templateUrl: './mapping-management.component.html',
  styleUrls: ['./mapping-management.component.less']
})
export class MappingManagementComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() partnerUser: PMSPartnerUser;
  @ViewChild('searchVal', {}) searchVal: ElementRef;
  existingMappings: PMSPartnerClientHinge[] = [];
  mappingsLoaded: boolean = false;

  searchValue: string;
  selectedClient: Client;

  private clientList: Client[];
  public filteredClients: Client[];

  $getMappingSub : Subscription;

  constructor(public modalService: NgbModal, private pmsService: PmsManagementService, private toast: ToastrService, public clientService: ClientService) { }
  ngOnDestroy(): void {
    if(this.$getMappingSub) this.$getMappingSub.unsubscribe();
  }
  ngAfterViewInit(): void {

  }

  ngOnInit() {
    this.$getMappingSub = this.pmsService.GetPartnerMappings(this.partnerUser.id).subscribe((res: PMSPartnerClientHinge[]) => {
      if(res) {
        this.existingMappings = res;
        this.clientService.FetchLightClientList().subscribe((res: Client[]) => {
          this.clientList = res;
          this.filterClients();
          _.forEach(this.existingMappings, map => {
            let client = this.clientList.find(c => { return c.id === map.clientId });
            map.clientName = client.clientName;
            map.isActive = client.isActive;
          });
          this.mappingsLoaded = true;
        })
      }
    },
    err => { this.toast.error('Error fetching mappings', '', { disableTimeOut: true, closeButton: true }) },
    () => {})
  }

  cancel(): void {
    this.modalService.dismissAll();
  }

  deleteMapping(map: PMSPartnerClientHinge) {
    this.pmsService.DeleteClientMapping(map).subscribe(res => {
      if(res) {
        _.remove(this.existingMappings, m => { return m.clientId === map.clientId });
        this.toast.success('Mapping removed!', '');
      }
    },
    err => { this.toast.error('Error removing mapping', '', { closeButton: true, disableTimeOut: true }) },
    () => {});
  }

  save(cli: Client): void {
    //check to see if an existing mapping exists.. if so, show an error toast and don't save
    let mapExist = this.existingMappings.find(rec => {return rec.clientId === cli.id })
    if(mapExist) {
      this.toast.info('This mapping already exists.');
      return;
    }

    let newMap: PMSPartnerClientHinge = new PMSPartnerClientHinge();
    newMap.clientId = cli.id;
    newMap.partnerUserId = this.partnerUser.id;
    newMap.clientName = cli.clientName;
    this.pmsService.CreateClientMapping(newMap).subscribe((res: PMSPartnerClientHinge) => {
      if(res) {
        newMap.id = res.id;
        this.existingMappings.push(newMap);
        this.toast.success('Mapping saved!', '');
      }
    },
    err => { this.toast.error('Error saving mapping', '', { closeButton: true, disableTimeOut: true }) },
    () => {});
  }

  public filterClients() {
    if(this.searchValue) {
      this.filteredClients = _.filter(this.clientList, c => { return c.clientName.toLowerCase().includes(this.searchValue.toLowerCase()) })
    }
    else {
      this.filteredClients = this.clientList;
    }
  }

}
